<template>
  <Wrapper>
    <main class="inventory_delivery-content">
      <header>
        <div v-if="isMobile" class="header_name">
          <span
            @click="inventoryType = {}"
            class="mck"
            v-if="inventoryType.value && isMobile"
            >M</span
          >
          <h1>
            Инвентар
            <template v-if="inventoryType.value">
              &gt; {{ inventoryType.name }}
            </template>
          </h1>
        </div>

        <div
          v-if="isMobile ? !inventoryType.value : true"
          class="tabs"
          :class="{
            'tabs--bottom': !isMobile,
          }"
        >
          <section
            v-for="mv of inventoryTypes"
            class="tab"
            :class="{
              'tab--main': !isMobile,
              'tab-active': inventoryType.value === mv.value,
            }"
            :key="`tab-${mv.name}`"
            @click="updateMainView(mv)"
            v-show="showTab(mv)"
          >
            <div>
              <img
                v-if="isMobile"
                :src="require(`@/assets/img/inventory/${mv.value}.svg`)"
                alt="tab img"
              />
              <p>{{ mv.name }}</p>
            </div>
            <span v-if="isMobile" class="mck">M</span>
          </section>
        </div>

        <section class="btns-wrapper" v-if="inventoryType.value">
          <TheInput
            v-if="!childType"
            showAsIcon="g"
            prop="name"
            propValue="value"
            type="dropdown"
            :fixed="true"
            :options="tabsContent"
            fixedLabel="ФИЛТРИРАНЕ"
            v-model="tab"
            @update:modelValue="tab = $event"
          />

          <TheInput
            showAsIcon="2"
            prop="name"
            propValue="value"
            type="dropdown"
            :fixed="true"
            :isSort="true"
            :options="sortTypes"
            fixedLabel="СОРТИРАНЕ"
            v-model="sortBy"
            @update:modelValue="updateSort($event)"
          />
          <button
            class="btn btn-excel"
            v-if="locationType"
            @click="isHistoryModalOpened = true"
          >
            История по локация
          </button>
          <button v-if="!childType" class="btn btn-new" @click="addInventory()">
            <span class="mck">L</span>
            Добави инвентар
          </button>
          <button
            v-if="canExport"
            class="btn btn-excel"
            :disabled="!inventories.length"
            @click="exportToExcelFile()"
          >
            <span class="mck">E</span>
            {{
              `СПРАВКА ${inventoryType.value === "car" ? "АВТОМОБИЛИ" : "ТМ"}`
            }}
          </button>
        </section>
      </header>

      <template v-if="inventoryType.value">
        <section class="mobile-content mobile">
          <div class="no-results" v-if="!inventories.length">
            <p>Няма намерени резултати</p>
          </div>
          <div
            class="mobile-content_element mobile-content_element--inventory"
            v-else
            v-for="i of inventories"
            :key="i._id"
            :class="{
              'tr-moving': i.status === 'moving',
            }"
            @click="openInventoryActions(i)"
          >
            <TheFixedDropdown
              v-if="i.showActions"
              prop="name"
              label="ДЕЙСТВИЯ"
              :arr="getInvActions(i)"
              @selected="handleAction($event.value, i)"
              @close="closeActions(i)"
            />

            <section class="content">
              <div class="row">
                <p><strong>ИМЕ:</strong></p>
                <span v-if="i.parent">{{ i.parent.name }}</span>
                <span v-else>{{ i.name }}</span>
              </div>
              <div class="row">
                <p><strong>МАРКА/МОДЕЛ:</strong></p>
                <span v-if="i.parent">{{ i.parent.brand }}</span>
                <span v-else>{{ i.brand }}</span>
              </div>
              <div class="row">
                <p><strong>СЕРИЕН НОМЕР:</strong></p>
                <span v-if="i.parent">{{ i.parent.serialNumber }}</span>
                <span v-else>{{ i.serialNumber }}</span>
              </div>

              <template v-if="locationType">
                <div class="row">
                  <p><strong>ЧАСОВА СТАВКА, €:</strong></p>
                  <span v-if="i.hourlyRate">{{ i.hourlyRate }}</span>
                </div>
                <div class="row">
                  <p><strong>ПРИЕЛ:</strong></p>
                  <span v-if="i.confirmedBy">{{ i.confirmedBy.name }}</span>
                </div>
                <div class="row">
                  <p><strong>ЛОКАЦИЯ:</strong></p>
                  <span class="select-object">
                    <template v-if="!i.location">ИЗБЕРИ ОБЕКТ</template>
                    <template v-else>
                      {{ i.location.companyName }} &gt;
                      {{ i.location.projectName }}
                    </template>
                  </span>
                </div>
              </template>
              <template v-if="userType">
                <div class="row">
                  <p><strong>СЛУЖИТЕЛ:</strong></p>
                  <span v-if="i.user">{{ i.user.name }}</span>
                </div>
                <div class="row">
                  <p><strong>ЗАЧИСЛЕН НА ДАТА:</strong></p>
                  <TheInput
                    type="datepicker"
                    icon="D"
                    :invalid="i.user && !i.date"
                    :leftPos="true"
                    :disabled="!i.user || i.scrappedOn"
                    placeholder="ДАТА"
                    v-model="i.date"
                    @update:modelValue="updateInventory(i, 'date', $event)"
                  />
                </div>
                <div class="row">
                  <p><strong>ВЪРНАТ НА ДАТА:</strong></p>
                  <TheInput
                    type="datepicker"
                    icon="D"
                    :disabled="!i.user || !i.date || i.scrappedOn"
                    placeholder="ДАТА"
                    v-model="i.returnedOn"
                    @update:modelValue="
                      updateInventory(i, 'returnedOn', $event)
                    "
                  />
                </div>
                <div class="row">
                  <p><strong>БРАКУВАН/ДАТА:</strong></p>
                  <TheInput
                    type="datepicker"
                    icon="D"
                    :disabled="!i.user || !i.date"
                    placeholder="ДАТА"
                    v-model="i.scrappedOn"
                    @update:modelValue="
                      updateInventory(i, 'scrappedOn', $event)
                    "
                  />
                </div>
              </template>
              <template v-if="childType">
                <div class="row">
                  <p><strong>ОПИСАНИЕ:</strong></p>
                  <span>{{ i.description }}</span>
                </div>
                <div v-if="inventoryType.value !== 'car'" class="row">
                  <p><strong>ЛОКАЦИЯ :</strong></p>
                  <span v-if="i.parent.location">
                    {{ i.parent.location.companyName }} &gt;
                    {{ i.parent.location.projectName }}</span
                  >
                </div>

                <div class="row">
                  <p><strong>СЛУЖИТЕЛ :</strong></p>
                  <span v-if="i.parent.confirmedBy">{{
                    i.parent.confirmedBy.name
                  }}</span>
                  <span v-if="i.parent.user">{{ i.parent.user.name }}</span>
                </div>
                <div class="row">
                  <p><strong>КИЛОМЕТРИ КЪМ:</strong></p>
                  <span>
                    {{ formatNumber(getField(i, "serviceInfo", "km")) }} км. /
                    {{ getField(i, "serviceInfo", "kmDate", true) }}</span
                  >
                </div>
                <div class="row">
                  <p><strong>ГТП:</strong></p>

                  <span>
                    <TableCell
                      :date="getField(i, 'serviceInfo', 'gtp', true)"
                    />
                  </span>
                </div>
                <div class="row">
                  <p><strong>ВИНЕТКА:</strong></p>
                  <span>
                    <TableCell
                      :date="getField(i, 'serviceInfo', 'vinetka', true)"
                    />
                  </span>
                </div>
                <div class="row">
                  <p><strong>КАСКО:</strong></p>
                  <span>
                    <TableCell
                      :date="getField(i, 'serviceInfo', 'kasko', true)"
                    />
                  </span>
                </div>
                <div class="row">
                  <p><strong>ГО:</strong></p>
                  <span>
                    <TableCell
                      :date="getField(i, 'serviceInfo', 'grajdanska', true)"
                    />
                  </span>
                </div>
                <div class="row">
                  <p><strong>ЛИЗИНГ:</strong></p>
                  <span>
                    <TableCell
                      :date="getField(i, 'serviceInfo', 'lizing', true)"
                    />
                  </span>
                </div>
              </template>

              <div class="row">
                <p><strong>ЗАБЕЛЕЖКА:</strong></p>
                <span>{{ i.parent ? i.parent.note : i.note }}</span>
              </div>
            </section>
            <section>
              <Status
                v-if="!childType"
                :s="i.status"
                :awaiting="i.location ? !i.location.confirmed : false"
              />
            </section>
          </div>
        </section>
        <!-- DESKTOP TABLE WITH INVENTORIES (ACTIVE AND INACTIVE) -->
        <div v-if="!isMobile" class="table-wrapper table-wrapper--new">
          <table class="table inventory-table">
            <thead>
              <tr>
                <th>ИМЕ</th>
                <th>МАРКА/МОДЕЛ</th>
                <th>СЕРИЕН НОМЕР</th>
                <template v-if="childType">
                  <th>ОПИСАНИЕ</th>
                  <th v-if="inventoryType.value !== 'car'">
                    ТЕКУЩА ЛОКАЦИЯ ОБЕКТ
                  </th>
                  <th>СЛУЖИТЕЛ</th>
                  <th>КИЛОМЕТРИ КЪМ</th>
                  <th>МОТОЧАСА КЪМ</th>
                  <th>ГТП</th>
                  <th>ВИНЕТКА</th>
                  <th>КАСКО</th>
                  <th>ГО</th>
                  <th>ЛИЗИНГ</th>
                </template>
                <template v-if="locationType">
                  <th>ЧАСОВА СТАВКА, €</th>
                  <th>ТЕКУЩА ЛОКАЦИЯ ОБЕКТ</th>
                  <th>ПРИЕЛ</th>
                  <th>ЧАСТ</th>
                </template>
                <template v-if="userType">
                  <th>ЗАЧИСЛЕН НА СЛУЖИТЕЛ</th>
                  <th>ЗАЧИСЛЕН НА ДАТА</th>
                  <th>ВЪРНАТ НА ДАТА</th>
                  <th>БРАКУВАН/ДАТА</th>
                </template>

                <th>ДЕЙСТВИЯ</th>
                <th>ЗАБЕЛЕЖКА</th>
                <th v-if="!childType">СТАТУС/СЪСТОЯНИЕ</th>
              </tr>
            </thead>
            <tbody v-if="!inventories.length">
              <tr>
                <td :colspan="childType ? 14 : 10" class="center">
                  Няма намерени резултати
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr
                v-for="i of inventories"
                :key="i._id"
                :class="{
                  'tr-moving': i.status === 'moving',
                }"
              >
                <template v-if="childType">
                  <TableCell :highlight="true" :content="i.parent.name" />
                  <TableCell :highlight="true" :content="i.parent.brand" />
                  <TableCell
                    :highlight="true"
                    :content="i.parent.serialNumber"
                  />
                  <TableCell :content="i.description" />
                  <TableCell
                    v-if="inventoryType.value !== 'car'"
                    :highlight="true"
                  >
                    <template v-if="i.parent.location">
                      {{ i.parent.location.companyName }} &gt;
                      {{ i.parent.location.projectName }}
                    </template>
                  </TableCell>
                  <TableCell :highlight="true">
                    <template v-if="i.parent.confirmedBy">
                      {{ i.parent.confirmedBy.name }}
                    </template>
                    <template v-if="i.parent.user">
                      {{ i.parent.user.name }}
                    </template>
                  </TableCell>
                  <TableCell>
                    {{ formatNumber(getField(i, "serviceInfo", "km")) }} км. /
                    {{ getField(i, "serviceInfo", "kmDate", true) }}
                  </TableCell>
                  <TableCell>
                    {{ formatNumber(getField(i, "serviceInfo", "mh")) }} мч. /
                    {{ getField(i, "serviceInfo", "mhDate", true) }}
                  </TableCell>
                  <TableCell :date="getField(i, 'serviceInfo', 'gtp', true)" />
                  <TableCell
                    :date="getField(i, 'serviceInfo', 'vinetka', true)"
                  />
                  <TableCell
                    :date="getField(i, 'serviceInfo', 'kasko', true)"
                  />
                  <TableCell
                    :date="getField(i, 'serviceInfo', 'grajdanska', true)"
                  />
                  <TableCell
                    :date="getField(i, 'serviceInfo', 'lizing', true)"
                  />
                </template>
                <template v-else>
                  <TableCell :content="i.name" />
                  <TableCell :content="i.brand" />
                  <TableCell :content="i.serialNumber" />
                  <template v-if="locationType">
                    <TableCell :content="i.hourlyRate" />
                    <TableCell>
                      <div class="actions-group">
                        <button
                          class="select-object"
                          :class="{ selected: i.location }"
                          :disabled="i.status === 'moving' || isInvDisabled(i)"
                          @click.stop="
                            isInvDisabled(i) ? null : (selectLocation = i._id)
                          "
                        >
                          <template v-if="!i.location">ИЗБЕРИ ОБЕКТ</template>
                          <template v-else>
                            {{ i.location.companyName }} &gt;
                            {{ i.location.projectName }}
                          </template>
                        </button>
                        <template v-if="i.status === 'moving'">
                          <button
                            class="accept-location"
                            v-if="getUser._id === i.location.reporter._id"
                            @click.stop="openConfirmModal(i)"
                          >
                            <span class="mck">_</span>
                            <span>ПРИЕМИ</span>
                          </button>
                          <span class="awaiting-confirmation" v-else>
                            <span class="mck">^</span>
                            <strong
                              >Изчаква приемане от
                              {{ i.location.reporter.name }}</strong
                            >
                          </span>
                        </template>
                      </div>
                    </TableCell>
                    <TableCell
                      :content="i.confirmedBy ? i.confirmedBy.name : ''"
                    />
                    <TableCell>
                      <TheInput
                        type="dropdown"
                        iconOptions="i"
                        :disabled="
                          isInvDisabled(i) ||
                          !i.location ||
                          (i.status !== 'onsite' && i.status !== 'moving')
                        "
                        :options="i.location ? i.location.parts : []"
                        :placeholder="i.part || 'Част'"
                        @update:modelValue="updateInventory(i, 'part', $event)"
                      />
                    </TableCell>
                  </template>
                  <template v-if="userType">
                    <TableCell>
                      <p v-if="i.user">{{ i.user.name }}</p>
                      <u
                        @click="handleAction('addUser', i)"
                        v-else-if="!i.user && accessCache['lps_all'] === 'edit'"
                        >ДОБАВИ СЛУЖИТЕЛ</u
                      >
                    </TableCell>
                    <TableCell>
                      <TheInput
                        type="datepicker"
                        icon="D"
                        :invalid="i.user && !i.date"
                        :disabled="isInvDisabled(i) || !i.user || i.scrappedOn"
                        placeholder="ИЗБЕРИ ДАТА"
                        v-model="i.date"
                        @update:modelValue="updateInventory(i, 'date', $event)"
                      />
                    </TableCell>
                    <TableCell>
                      <TheInput
                        type="datepicker"
                        icon="D"
                        :disabled="
                          accessCache['lps_returned_on'] !== 'edit' ||
                          !i.user ||
                          !i.date ||
                          i.scrappedOn
                        "
                        placeholder="ИЗБЕРИ ДАТА"
                        v-model="i.returnedOn"
                        @update:modelValue="
                          updateInventory(i, 'returnedOn', $event)
                        "
                      />
                    </TableCell>
                    <TableCell>
                      <TheInput
                        type="datepicker"
                        icon="D"
                        :disabled="
                          accessCache['lps_scrapped_on'] !== 'edit' ||
                          !i.user ||
                          !i.date
                        "
                        placeholder="ИЗБЕРИ ДАТА"
                        v-model="i.scrappedOn"
                        @update:modelValue="
                          updateInventory(i, 'scrappedOn', $event)
                        "
                      />
                    </TableCell>
                  </template>
                </template>
                <TableCell>
                  <TheInput
                    prop="name"
                    type="dropdown"
                    :options="getInvActions(i)"
                    placeholder="Действия"
                    @update:modelValue="handleAction($event.value, i)"
                  />
                </TableCell>
                <TableCell
                  :class="{ highlight: childType }"
                  :content="i.parent ? i.parent.note : i.note"
                />
                <TableCell v-if="!childType">
                  <Status
                    :s="i.status"
                    :awaiting="i.location ? !i.location.confirmed : false"
                  />
                </TableCell>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination
          :currentPage="page"
          :size="size"
          :total="totalInventories"
          @updage:page="pageChanged"
        />
      </template>

      <InventoryModal
        v-if="idToEdit || isInventoryModalOpened"
        :idToEdit="idToEdit"
        :type="inventoryType.value"
        @close="handleCloseInventoryModal"
      />
      <transition name="fade">
        <InventoryConfirmModal
          v-if="isConfirmModalOpen"
          :id="isConfirmModalOpen"
          @close="confirmInventory($event)"
        />
      </transition>
      <transition name="fade">
        <InventoryLocationModal
          v-if="selectLocation"
          :id="selectLocation"
          @close="handleCloseInventoryLocationModal"
        />
      </transition>
      <transition name="fade">
        <FilesModal
          v-if="isFilesModalOpened"
          type="inventory"
          :id="isFilesModalOpened"
          @close="closeFilesModal"
        />
      </transition>
      <transition name="fade">
        <InventoryHistoryModal
          v-if="selectHistory || isHistoryModalOpened"
          :id="selectHistory"
          :showEvents="showEvents"
          @close="closeHistoryModal()"
        />
      </transition>
      <transition name="fade">
        <AddUsersModal
          v-if="isAddUserModalOpen"
          :onlySingleUser="true"
          :incomingUsers="isAddUserModalOpen.user && [isAddUserModalOpen.user]"
          @close="closeAddUsersModal(isAddUserModalOpen, $event)"
        />
      </transition>
    </main>
  </Wrapper>
</template>

<script>
import { format } from "date-fns";
import { getAccess } from "./mixins/getAccess";
import { mapGetters } from "vuex";
import InventoryModal from "./inventory/InventoryModal.vue";
import InventoryConfirmModal from "./inventory/InventoryConfirmModal.vue";
import InventoryLocationModal from "./inventory/InventoryLocationModal.vue";
import InventoryHistoryModal from "./inventory/InventoryHistoryModal.vue";
import AddUsersModal from "./shared/AddUsersModal";
import TheInput from "@/components/TheInput";
import Wrapper from "@/components/Wrapper";
import TheFixedDropdown from "@/components/TheFixedDropdown";
import FilesModal from "@/components/shared/FilesModal";
import TableCell from "@/components/shared/TableCell.vue";
import Pagination from "@/components/shared/Pagination.vue";
import Status from "./shared/Status.vue";
import tabsData from "../data/tabsData";
import getMobile from "./mixins/getMobile.js";
export default {
  mixins: [getMobile],
  components: {
    Status,
    Wrapper,
    TheInput,
    TableCell,
    FilesModal,
    Pagination,
    AddUsersModal,
    InventoryModal,
    TheFixedDropdown,
    InventoryLocationModal,
    InventoryHistoryModal,
    InventoryConfirmModal,
  },
  data() {
    return {
      tabsData,
      isHistoryModalOpened: false,
      isFilesModalOpened: false,
      openedDropdown: false,
      isInventoryModalOpened: false,
      isAddUserModalOpen: false,
      isConfirmModalOpen: null,
      selectLocation: null,
      selectHistory: null,
      showEvents: null,
      idToEdit: "",
      inventoryType: {},
      accessCache: {},
      sortBy: {},
      page: Number.parseInt(this.$route.query.page) || 1,
      size: 40,
      inventories: [],
      totalInventories: 0,
      tab: { value: "all" },
      search: "",
      actions: [
        { name: "Виж историята", icon: "D", value: "selectHistory" },
        { name: "Редактирай данни", icon: ",", value: "idToEdit" },
        { name: "Споделяне", icon: ".", value: "share" },
      ],
      inventoryTypes: [
        {
          name: "Инструменти",
          value: "tool",
          accessNames: ["tools_own", "tools_all"],
        },
        {
          name: "Строителна техника",
          value: "equipment",
          accessNames: ["mechanizations_own", "mechanizations_all"],
        },
        {
          name: "Тежка механизация",
          value: "heavy_machinery",
          accessNames: ["heavy_machinery_own", "heavy_machinery_all"],
        },
        {
          name: "Завод Перник",
          value: "pernik",
          accessNames: ["pernik_own", "pernik_all"],
        },
        {
          name: "Служебен инвентар и ЛПС",
          value: "user_inventory",
          accessNames: [
            "lps_own",
            "lps_all",
            "lps_returned_on",
            "lps_scrapped_on",
          ],
        },
        {
          name: "Автомобили ",
          value: "car",
          accessNames: ["car_own", "car_all"],
        },
      ],
      // set all access to the 0 index
      inventoryAccessTypes: {
        tool: ["tools_all", "tools_own"],
        equipment: ["mechanizations_all", "mechanizations_own"],
        heavy_machinery: ["heavy_machinery_all", "heavy_machinery_own"],
        pernik: ["pernik_all", "pernik_own"],
        user_inventory: ["lps_all", "lps_own"],
        car: ["car_all", "car_own"],
      },
      tabsContent: [
        { name: "всички инструменти", value: "all" },
        { name: "НА ОБЕКТИ", value: "onsite" },
        { name: "СВОБОДНИ", value: "" },
        { name: "ЗА РЕМОНТ", value: "repair" },
        { name: "БРАКУВАНИ", value: "scrap" },
        { name: "ЛИПСВАЩИ", value: "missing" },
      ],
      sortTypes: [
        {
          name: "Сортирай по дата на въвеждане",
          value: "createdAt",
        },
        { name: "Сортирай по дата на редакция", value: "updatedAt" },
        { name: "Сортирай по азбучен ред", value: "name" },
        { name: "Сортирай по служител", value: "confirmedBy.name" },
        { name: "Сортирай по Обект", value: "location.projectName" },
      ],
    };
  },
  watch: {
    search() {
      this.getInventories();
    },
    tab() {
      this.getInventories();
    },
    isMobile() {
      if (this.isMobile) this.inventoryType = {};
      else this.setInventoryType();
    },
  },
  computed: {
    ...mapGetters(["getUser"]),
    locationType() {
      return ["tool", "equipment"].includes(this.inventoryType.value);
    },
    userType() {
      return ["user_inventory", "pernik"].includes(this.inventoryType.value);
    },
    childType() {
      return ["heavy_machinery", "car"].includes(this.inventoryType.value);
    },
    canExport() {
      let inquiryNames = {
        heavy_machinery: "heavy_machinery_inquiry",
        car: "car_inquiry",
      };

      if (
        this.childType &&
        inquiryNames[this.inventoryType.value] &&
        this.accessCache[inquiryNames[this.inventoryType.value]]
      ) {
        return true;
      } else return false;
    },
  },
  methods: {
    pageChanged(page) {
      this.page = page;
      this.getInventories();
    },
    formatNumber(number) {
      return new Intl.NumberFormat("de-CH").format(number);
    },
    getField(i, field, nestedField, returnDate) {
      var value = i && i[field] && i[field][nestedField];
      if (returnDate && value) {
        return format(new Date(value), "dd.MM.yyyy");
      }
      return value || "";
    },
    showTab(mv) {
      return mv.accessNames.some((a) => this.accessCache[a]);
    },
    getInvActions(i) {
      let actions = [...this.actions];

      if (window.innerWidth < 1000) {
        if (
          this.locationType &&
          i.status === "moving" &&
          this.getUser._id === i.location.reporter._id
        ) {
          actions.push({
            name: "Приеми",
            icon: "/",
            value: "isConfirmModalOpen",
          });
        } else if (
          (!i.user && this.inventoryType.value === "user_inventory") ||
          this.inventoryType.value === "pernik"
        ) {
          actions.push({
            name: "Избери служител",
            icon: "/",
            value: "addUser",
          });
        }
      }

      if (
        this.userType &&
        this.accessCache["lps_all"] === "edit" &&
        i.user &&
        i.returnedOn &&
        !i.scrappedOn
      ) {
        actions.push({
          name: "Зачисли на друг служител",
          icon: "/",
          value: "addUser",
        });
      }

      if (this.childType) {
        actions.push(
          { name: "История разходи", icon: "D", value: "selectHistory" },
          {
            name: "История регистър забележки",
            icon: "D",
            value: "selectHistoryEvents",
          }
        );

        if (i.files && i.files.length) {
          actions.push({
            name: "Виж документацията",
            icon: "Q",
            value: "isFilesModalOpened",
          });
        }

        actions.shift();
      }
      // check if user has edit access
      if (this.isInvDisabled(i)) {
        actions = actions.filter((a) => a.value !== "idToEdit");
      }

      return actions;
    },
    isInvDisabled(i) {
      const accessKeys = this.inventoryAccessTypes[this.inventoryType.value];
      const allAccess = this.accessCache[accessKeys[0]];
      const ownAccess = this.accessCache[accessKeys[1]];
      let disabled = true;

      if (allAccess === "edit") {
        disabled = false;
        // in tool type user can edit all the inventories
      } else if (ownAccess === "edit" && i.type === "tool") {
        disabled = false;
      } else if (
        ownAccess === "edit" &&
        ((i.location && i.location.reporter._id === this.getUser._id) ||
          i.confirmedBy === this.getUser._id ||
          (i.user && i.user._id === this.getUser._id))
      ) {
        disabled = false;
      }

      return disabled;
    },
    addInventory() {
      const accessKeys = this.inventoryAccessTypes[this.inventoryType.value];
      let hasAnyAccess = accessKeys.some(
        (key) => this.accessCache[key] === "edit"
      );

      if (hasAnyAccess) {
        this.isInventoryModalOpened = true;
      } else {
        let noAccessTo = this.inventoryTypes.find(
          (t) => t.value === this.inventoryType.value
        );

        this.$snotify.warning(`Не можете да добавяте ${noAccessTo.name}`);
      }
    },
    updateSort(v) {
      this.sortBy = v;
      this.updateRoute();
    },
    async handleAction(v, i) {
      if (v === "share") {
        const baseUrl = window.location.href;
        const newUrl = `${baseUrl}&inventoryId=${i._id}`;

        // copy inventory URL to the clipboard
        const tempInput = document.createElement("input");
        tempInput.value = newUrl;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        this.$snotify.success(`Линкът е копиран`);
      } else if (v === "addUser") {
        // if "Зачисли" was clicked
        if (i.user) {
          delete i.date;
          delete i.returnedOn;
          delete i.user;
          await this.updateInventory(i);
        }

        this.isAddUserModalOpen = i;
      } else if (v === "selectHistoryEvents") {
        this.selectHistory = i._id;
        this.showEvents = true;
      } else this[v] = i._id;

      this.closeActions(i);
    },
    closeActions(i) {
      this.$set(i, "showActions", false);
    },
    updateMainView(v) {
      this.page = 1;
      this.inventoryType = v;
      this.setSortTypes();
      this.updateRoute();
    },
    updateRoute() {
      let query = { ...this.$route.query };
      this.getInventories();

      if (Object.entries(this.sortBy).length)
        query.sortBy = JSON.stringify(this.sortBy);
      else delete query.sortBy;
      query.inventoryType = this.inventoryType.value;

      this.$router.replace({ query }).catch(() => {});
    },
    handleEditLocationClick(inv) {
      this.selectLocation = inv._id;
      this.$set(inv, "showActions", false);
    },
    openInventoryActions(i) {
      this.$set(i, "showActions", true);
    },
    async exportToExcelFile() {
      try {
        let url = `${process.env.VUE_APP_BASE_URI}/inventory/logs?type=${this.inventoryType.value}&getExcel=true`;

        const res = await this.$http.get(url, { responseType: "blob" });

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Справка-инвентар.xlsx";
        link.click();
      } catch (err) {
        console.log(err);
      }
    },
    getInventories() {
      this.$store.dispatch("startLoading");
      this.inventories = [];

      let url = `${process.env.VUE_APP_BASE_URI}/inventory?inventoryType=${this.inventoryType.value}&page=${this.page}&size=${this.size}`;

      const hasAccessAll =
        this.inventoryAccessTypes[this.inventoryType.value][0];

      if (!this.accessCache[hasAccessAll]) {
        url += `&own=true&userId=${this.getUser._id}`;
      }

      if (this.$route.query.inventoryId) {
        url += `&inventoryId=${this.$route.query.inventoryId}`;
      }
      if (this.search) {
        url += `&search=${this.search}`;
      }
      if (this.tab.value !== "all") {
        url += `&status=${this.tab.value}`;
      }

      if (Object.entries(this.sortBy).length) {
        url += `&sortBy=${JSON.stringify(this.sortBy)}`;
      }

      this.$http.get(url).then((response) => {
        this.inventories = response.data.result;
        this.totalInventories = response.data.total;

        this.$nextTick(() => {
          if (this.$route.query.open) {
            this.handleAction("idToEdit", this.$route.query.open);
          }
          if (this.$route.query.confirm) {
            const inv = this.inventories.find(
              (i) => i._id === this.$route.query.confirm
            );

            if (inv) {
              if (
                inv.status === "moving" && inv.location
                  ? inv.location.reporter._id === this.getUser._id
                  : false
              ) {
                this.openConfirmModal(inv);
              }
            }
          }
        });

        this.$store.dispatch("stopLoading");
      });
    },
    openConfirmModal(inventory) {
      this.isConfirmModalOpen = inventory._id;
      this.$set(inventory, "showActions", false);
    },
    async updateInventory(inventory, field, value) {
      if (field) {
        inventory[field] = value;
      }

      try {
        const fd = new FormData();
        fd.append("data", JSON.stringify(inventory));

        await this.$http.put(`${process.env.VUE_APP_BASE_URI}/inventory`, fd);

        this.$snotify.success("Успешно редактирахте инвентар!");
        this.getInventories();
      } catch (error) {
        console.log(error.response);
        if (error.response && error.response.data) {
          this.$snotify.error(error.response.data);
        } else this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
      }
    },
    confirmInventory(inventory) {
      this.isConfirmModalOpen = null;

      if (inventory) {
        inventory.status = "onsite";
        inventory.confirmedBy = this.getUser._id;

        const fd = new FormData();
        fd.append("data", JSON.stringify(inventory));

        this.$http
          .put(`${process.env.VUE_APP_BASE_URI}/inventory`, fd)
          .then(() => {
            this.$snotify.success("Успешно потвърдихте локация на инвентар!");
            this.getInventories();
          })
          .catch((error) => {
            if (typeof error.response.data === "string") {
              this.$snotify.error(error.response.data);
            } else {
              console.log(error.response);
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            }
          })
          .then(() => {});
      }
    },
    closeHistoryModal() {
      this.isHistoryModalOpened = false;
      this.selectHistory = null;
      this.showEvents = null;
    },
    closeAddUsersModal(i, u) {
      if (u) {
        let user = u[0];
        i.user = user;
        this.updateInventory(i);
      }

      this.isAddUserModalOpen = false;
    },
    handleCloseInventoryModal(event) {
      this.isInventoryModalOpened = false;
      this.idToEdit = "";
      if (event.isEdited) {
        this.inventories = [];
        this.getInventories();
      }
    },
    closeFilesModal(isUpdated) {
      this.isFilesModalOpened = false;
      if (isUpdated) this.getInventories();
    },
    handleCloseInventoryLocationModal(event) {
      this.selectLocation = null;
      if (event.isEdited) {
        this.inventories = [];
        this.getInventories();
      }
    },
    setInventoryType() {
      // set inventoryType
      if (this.$route.query.inventoryType) {
        this.inventoryType = this.inventoryTypes.find(
          (i) => i.value === this.$route.query.inventoryType
        );
      } else {
        for (let a of this.inventoryTypes) {
          if (this.showTab(a)) {
            this.inventoryType = a;
            break;
          }
        }
      }
    },
    setAccessCache() {
      Object.keys(this.tabsData.inventory.tabValues).forEach((key) => {
        this.accessCache[key] = getAccess(key, "inventory");
      });
      this.setInventoryType();
    },
    setSortTypes() {
      // initial sort for locationType inventories
      const sortLocationMove = {
        name: "Сортирай по последно променена локация",
        value: "lastMovement",
      };

      if (this.locationType) {
        this.sortBy[sortLocationMove.value] = 1;

        if (!this.sortTypes.find((s) => s.value === sortLocationMove.value)) {
          this.sortTypes.unshift(sortLocationMove);
        }
      } else {
        this.sortBy["createdAt"] = 1;
        delete this.sortBy[sortLocationMove.value];

        if (this.sortTypes.find((s) => s.value === sortLocationMove.value)) {
          this.sortTypes.shift();
        }
      }
    },
  },
  async mounted() {
    this.setAccessCache();
    let query = { ...this.$route.query };

    if (query.openConfirmModal) {
      this.isConfirmModalOpen = this.$route.query.openConfirmModal;
      delete query.openConfirmModal;

      this.$router.replace(query);
    }

    if (this.$route.query.sortBy) {
      this.sortBy = JSON.parse(this.$route.query.sortBy);
    }
    await this.updateMainView(this.inventoryType, true);
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
    });
  },
  destroyed() {
    this.$off("closeInventoryModal");
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped lang="scss">
.nowrap {
  white-space: nowrap;
}

.actions-group {
  align-items: center;
  display: flex;
  gap: 4px;
}

.inventory-table {
  tbody td {
    transition: background-color 0.2s ease;
  }

  tbody tr:hover {
    td {
      background-color: #eef3ff;
    }
  }
}

.select-object,
.accept-location {
  background: #d3e2fb;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  color: #3b86ff;
  height: 22px;
  padding: 4px 12px;
  text-decoration: underline;
  user-select: none;
  width: initial;
}
.select-object.selected {
  background: #ececec;
  height: initial;
}
.select-object:disabled,
.select-object:disabled:hover {
  cursor: default;
  opacity: 0.5;
}
u {
  color: #3b86ff;
  cursor: pointer;
  font-weight: 500;
  text-decoration: underline;
  user-select: none;

  &:hover {
    opacity: 0.5;
  }
}
.actions {
  display: flex;
  gap: 5px;

  p {
    color: #3b86ff;
    cursor: pointer;
    font-weight: 500;
    text-decoration: underline;
    user-select: none;

    &:hover {
      opacity: 0.9;
    }
  }
}

.select-object:hover,
.accept-location:hover {
  opacity: 0.9;
}
.accept-location {
  align-items: center;
  background: #328247;
  color: #fff;
  display: inline-flex;
  gap: 4px;
  text-decoration: none;
}
.awaiting-confirmation {
  align-items: center;
  color: #c68e0b;
  display: inline-flex;
  gap: 4px;
}
.awaiting-confirmation .mck,
.accept-location .mck {
  font-size: 20px;
}
</style>
